import * as React from "react";
import type { SVGProps } from "react";
const SvgUser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19 21a1 1 0 1 0 2 0zm-3-6v-1zm-8 0v-1zm-4 4H3zm-1 2a1 1 0 1 0 2 0zm18 0v-2h-2v2zm0-2a5 5 0 0 0-1.465-3.536l-1.414 1.415A3 3 0 0 1 19 19zm-1.465-3.536A5 5 0 0 0 16 14v2a3 3 0 0 1 2.121.879zM16 14H8v2h8zm-8 0a5 5 0 0 0-3.536 1.464L5.88 16.88A3 3 0 0 1 8 16zm-3.536 1.464A5 5 0 0 0 3 19h2a3 3 0 0 1 .879-2.121zM3 19v2h2v-2zM15 7a3 3 0 0 1-3 3v2a5 5 0 0 0 5-5zm-3 3a3 3 0 0 1-3-3H7a5 5 0 0 0 5 5zM9 7a3 3 0 0 1 3-3V2a5 5 0 0 0-5 5zm3-3a3 3 0 0 1 3 3h2a5 5 0 0 0-5-5z"
    />
  </svg>
);
export default SvgUser;
